import apiInstance from "./apiInstance";

export class ProductServices{

    static getProductAPI(){
        return apiInstance.get('/api/get-products');
    }

    static getAddonProductAPI(){
        return apiInstance.get('/api/add-on-products');
    }

    static addDraftOrderAPI(payload){
        return apiInstance.post('/api/add-draft-order',payload);
    }

    static getCountriesAPI(){
        return apiInstance.get('/api/get-countries');
    }

    static getStatesApi(id){
        return apiInstance.get(`/api/get-states/${id}`);
    }

    static getCitiesApi(id){
        return apiInstance.get(`/api/get-cities/${id}`);
    }

    static addOrderApi(payload){
        return apiInstance.post('/api/add-order',payload);
    }

    static addBrandMentionOrderApi(payload){
        return apiInstance.post('/api/add-brand-mention-order', payload);
    }

    static getPlacementTypesAPI(){
        return apiInstance.get('/api/placement-types');
    }

    static addBalanceApi(payload){
        return apiInstance.post('/api/add-balance',payload);
    }

    static getOrdersApi(payload){
        return apiInstance.get(`/api/orders-list/${payload.per_page}?page=${payload.page}`,{ params: payload });
    }

    static getTabsDetailApi(){
        return apiInstance.get('/api/tabs-detail');
    }

    static applyCouponApi(payload){
        return apiInstance.post('/api/apply-coupon',payload);
    }

    static getExistingCardsAPI(){
        return apiInstance.get('/api/existing-card');
    }
    static getDraftOrderAPI(payload){
        return apiInstance.get(`/api/draft-order-list/${payload.per_page}?page=${payload.page}`,{ params: payload });
    }
    static deleteDraftOrderAPI(payload){
        return apiInstance.post('/api/delete-draft', payload);
    }

    static approvedDraftOrderAPI(payload){
        return apiInstance.post('/api/draft-orders-assign-approved-at', payload);
    }
    static domainDataAPI(payload){
        return apiInstance.post('/api/domain-data', payload);
    }
    static orderPlanCountDataAPI(){
        return apiInstance.get('/api/get-order-plan-count');
    }
    static selectedCardDetailApi(id){
        return apiInstance.get(`/api/get-card-detail/${id}`);
    }

    static getReferralCouponApi(){
        return apiInstance.get('/api/get-referral-coupon');
    }
    
    static getInvoicePaymentApi(token){
        return apiInstance.get('/api/invoice-payment', { params: { data: token } });
    }

    static validateInvoiceDraftOrdersApi(token){
        return apiInstance.get('/api/invoice-payment/validate-drafts', { params: { data: token } });
    }

    static createDraftCheckoutSessionApi(payload){
        return apiInstance.post('/api/draft-orders/checkout/session', payload);
    }

    static getDraftCheckoutPreviewApi(payload){
        return apiInstance.post('/api/draft-orders/checkout-preview', payload);
    }

    static validateDraftCheckoutApi(payload){
        return apiInstance.post('/api/draft-orders/checkout/validate', payload);
    }

    static validateDraftOrderApi(payload){
        return apiInstance.post('/api/draft-orders/validate', payload);
    }

    static payDraftCheckoutApi(payload){
        return apiInstance.post('/api/draft-orders/checkout/pay', payload);
    }

    static getInvoicePaymentCountriesApi(token){
        return apiInstance.get('/api/invoice-payment/countries', { params: { data: token } });
    }

    static getInvoicePaymentStatesApi(payload){
        const countryId = payload?.countryId ?? payload;
        const token = payload?.token;
        return apiInstance.get(`/api/invoice-payment/states/${countryId}`, { params: { data: token } });
    }

    static getInvoiceExistingCardsApi(token){
        return apiInstance.get('/api/invoice-payment/existing-cards', { params: { data: token } });
    }

    static getInvoiceCardDetailApi(payload){
        return apiInstance.get(`/api/invoice-payment/card-detail/${payload.id}`, {
            params: { data: payload.token },
        });
    }

    static invoiceStripeSavedPaymentMethodApi(payload){
        return apiInstance.post('/api/invoice-payment/stripe-saved-payment-method', payload);
    }

    static stripePaymentMethodApi(payload){
        return apiInstance.post('/api/stripe-payment-method', payload);
    }

    static invoiceStripePaymentMethodApi(payload){
        return apiInstance.post('/api/invoice-payment/stripe-payment-method', payload);
    }

    static invoiceAchPaymentIntentApi(payload){
        return apiInstance.post('/api/invoice-payment/ach-payment-intent', payload);
    }

    static orderAchPaymentIntentApi(payload){
        return apiInstance.post('/api/ach-payment-intent', payload);
    }

    static invoiceAchStartApi(payload){
        return apiInstance.post('/api/invoice-payment/ach-start', payload);
    }

    static invoicePayApi(payload){
        return apiInstance.post('/api/invoice-payment/pay', payload);
    }

    static downloadInvoicePaymentApi(token){
        return apiInstance.get('/api/invoice-payment/download', {
            params: { data: token },
            responseType: 'blob',
        });
    }

    static stripeSavePaymentMethodApi(payload){
        return apiInstance.post('/api/stripe-saved-payment-method', payload);
    }

    static getEditedOrderAPI(payload){
        return apiInstance.get(`/api/order-opprovals-list/${payload.per_page}?page=${payload.page}`,{ params: payload });
    }

    static getEditOrderLinksAPI(payload){
        return apiInstance.get(`/api/order-opproval-links/${payload.per_page}?page=${payload.page}`,{ params: payload });
    }

    static addOrderBalanceAPI(payload){
        return apiInstance.post('/api/add-order-balance', payload);
    }

    static editOrderPaymentAPI(payload){
        return apiInstance.post('/api/edit-order-payment',payload);
    }

    static approveEditedOrderAPI(payload){
        return apiInstance.post('/api/approve-order-opprovals', payload);
    }

    static updateOrderDataAPI(payload){
        return apiInstance.post('/api/update-order-title',payload);
    }

    static updateLinkDetailsAPI(payload){
        return apiInstance.post('/api/update-link-details',payload);
    }
}